export { default } from './NotifyText';
